import "./style.css";

export default class CookieBanner {
  static selector = ".cookie-banner";

  constructor(block) {
    this.block = block;

    const cookiePolicy = window.localStorage.getItem("cookiePolicy");
    if (cookiePolicy) {
      this.hideCookieBanner();
    } else {
      this.okLink = block.querySelector(".accept-cookies");
      this.okLink.addEventListener("click", this.onOkClicked);
    }
  }

  hideCookieBanner = () => {
    this.block.style.display = "none";
  };

  onOkClicked = () => {
    this.block.addEventListener("transitionend", this.onBlockTransitionEnded);
    this.block.style.opacity = "0";
    window.localStorage.setItem("cookiePolicy", '1');
  };

  onBlockTransitionEnded = () => {
    this.block.removeEventListener("transitionend", this.onBlockTransitionEnded);
    this.hideCookieBanner();
  }
}
